export default "__VITE_ASSET__bbbc80a0__"